<template>
    <div
        v-if="isVisible"
        @click.stop="handleFrameClick"
        @contextmenu.prevent.stop="handleContextMenu"
        @mousedown.stop="handleMouseDown"
        @mouseup.stop="handleMouseUp"
        @mousemove.stop="handleMouseMove"
        @mouseover.stop="handleMouseOver"
        @mouseleave="handleMouseLeave"
        :style="labelStyle"
        :class="[
            'interactive-label',
            {
                [`interactive-label--${this.shape.options.text.basic.arrow_direction}`]:
                    this.shape.options.text.basic.arrow_direction,
                selected: selected,
            },
        ]"
    >
        <span class="interactive-label-text" v-if="shape.translations.content">
            {{ contentTranslate }}
        </span>
    </div>
</template>

<script>
import { LayerShapeMixin } from "./LayerShapeMixin.js";

export default {
    name: "Label",
    mixins: [LayerShapeMixin],

    computed: {
        labelStyle() {
            const center = this.shape?.center || { x: 0, y: 0 };
            const options = this.shape?.options || {};
            const text = options?.text || {};
            const basic = text?.basic || {};
            const currentStyle = text?.[this.style] || {};
            const padding = basic?.padding || {};
            const stroke = basic?.stroke || {};

            const paddingX = padding.x || 0;
            const paddingY = padding.y || 0;

            const borderColor = currentStyle?.stroke?.color || "#000";
            const backgroundColor = currentStyle?.fill?.color || "#fff";
            const color = currentStyle?.text?.color || "#000";

            const arrowDirection = basic?.arrow_direction || "hidden";

            let translateX = "-50%";
            let translateY = "-50%";

            // Корректировка трансформации на основе направления стрелки
            switch (arrowDirection) {
                case "left":
                    translateX = "10px";
                    translateY = "-50%";
                    break;
                case "right":
                    translateX = "calc(-100% - 10px)";
                    translateY = "-50%";
                    break;
                case "top":
                    translateX = "-50%";
                    translateY = "10px";
                    break;
                case "bottom":
                    translateX = "-50%";
                    translateY = "calc(-100% - 10px)";
                    break;
                default:
                    translateX = "-50%";
                    translateY = "-50%";
            }

            const textSize = basic?.text?.size || 14;
            const strokeWidth = currentStyle?.stroke?.width || 1;
            const strokeRadius = stroke?.radius || 0;

            return {
                top: `${center.y ? center.y / this.aspectRatio : 0}px`,
                left: `${center.x ? center.x / this.aspectRatio : 0}px`,
                padding: `${paddingY}px ${paddingX}px`,
                background: backgroundColor,
                zIndex: 3,
                border: `${strokeWidth}px solid ${borderColor}`,
                borderRadius: `${strokeRadius}px`,
                color: color,
                fontSize: `${textSize}px`,
                transform: `scale(${this.scale}) translate(${translateX}, ${translateY})`,
                transformOrigin: "left top",
                "--arrow-border-color": borderColor,
                "--border-width": `${strokeWidth}px`,
            };
        },
    },
};
</script>
